import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {MANY_RECORDS_LENGTH} from '../util/Util';

@Injectable()
export class GreydomPaginatorIntl extends MatPaginatorIntl {
  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 of ${this.getLengthLabel(length)}`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} of ${this.getLengthLabel(length)}`;
  };

  private getLengthLabel(length: number): string {
    return length === MANY_RECORDS_LENGTH ? 'many results' : String(length);
  }
}
